import { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Utils
import useRequest from "../../utils/useRequest";

import { UserAuth } from "../../utils/AuthContext";

// Components
import FabricOrderList from "./FabricOrderList";
import PageWrapper from "../../components/PageWrapper";
import Loader from "../../components/Loader";

export default function FabricOrderPage() {
  // HOOKS
  const { id } = useParams();

  // STATES
  const [fabricOrderItems, setFabricOrderItems] = useState([]);
  const [orderStatus, setOrderStatus] = useState("PENDING");

  // ENDPOINTS
  const { loading, error, data, refetch } = useRequest(
    `/getOneFabricOrder/${id}`,
    "GET",
    null,
    {},
    true
  );

  useEffect(() => {
    if (data) {
      setFabricOrderItems(data);
      setOrderStatus(data?.status);
    }
  }, [data]);

  return (
    <PageWrapper withBackButton>
      <div className="u-margin--top_500 u-margin--bottom_500">
        {loading ? (
          <Loader />
        ) : (
          <FabricOrderList
            data={fabricOrderItems}
            setData={setFabricOrderItems}
            orderStatus={orderStatus}
          />
        )}
      </div>
    </PageWrapper>
  );
}
